export var HERO_IMAGE_COMPONENT_ID = 'hero_image';
export var HERO_CONTENT_COMPONENT_ID = 'hero_content';
export var HERO_FEATURED_CONTENT_COMPONENT_ID = 'hero_featured_content';